(function () {
    'use strict';

    a3_cabin_reports.directive('history', history);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name history
    * @restrict E
    * @description
    *   Implementation of history
    * @example
    *   Usage:
    *   <history></history>
    * @ngInject
    */
    function history(ToolkitFactory, CustomerEventHistoryFactory) {
        function link(scope) {
            scope.history = CustomerEventHistoryFactory.getPassengerHistory(scope.passenger);
        }
        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/OneStopShop/history.tpl.html',
            scope: false,
            link: link
        }
    }

})();
